<template>
	<v-app>
		<v-toolbar v-if="isLoggedIn" color="indigo-darken-4" class="mb-4">
			<v-img :src="rpBanner" class="mr-4 cursor-pointer" @click="router.push('/')" style="width:200px"></v-img>
			<v-btn @click="logout" class="ml-2" icon="fa-solid fa-right-from-bracket" />
		</v-toolbar>
		<router-view v-if="isLoggedIn || route.path == '/login'"/>
	</v-app>
</template>

<script>
import { onBeforeMount, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import * as rosepetalModel from 'rosepetal-model';
import config from '@/etc/rosepetal.json';
import rpBanner from '@/assets/logos/rp_banner_white.png'
import { signOut } from "firebase/auth";


export default {
	setup() {
		const router = useRouter();
		const route = useRoute();
		const isLoggedIn = ref(false); 
		const firebase = rosepetalModel.default._firebase;
		const user = rosepetalModel.default.user;
		firebase.initializeApp(config.firebaseConfig);
		firebase.setHost(config);

		async function logout() {
			sessionStorage.clear();
			router.replace('/login');
			signOut(firebase.auth).then(() => console.log('')).catch(err => alert(err.message));
			isLoggedIn.value = false;
		}

		onBeforeMount(async () => {
			let auth = firebase.auth;
			auth.onAuthStateChanged(async (authUser) => {
				if (authUser) {
					isLoggedIn.value = true;
					authUser.role = await user.getRole(authUser.email);
				}

				if (!authUser) {
					sessionStorage.setItem('redirect', route.fullPath);
					router.replace('/login');
				}

				else if (route.path == "/login" || route.path == "/register") {
					router.replace("/");
				}
			});
		});

		return {
			rpBanner,
			router,
			route,
			logout,
			isLoggedIn,
			firebase,
			user
		}
	},
}
</script>

<style>
body {
	padding: 0 !important;
	margin: 0;
}
</style>